module.exports = __webpack_public_path__ + "media/luxury-2026/beamed-dining-5bc6059e.jpg";